import { useAppDispatch, useAppSelector } from '@/redux/global-hooks';
import {
  selectMission,
  setMission as _setMission,
  clearMission as _clearMission,
} from '@/redux/slices/mission.slice';

export default function useMission() {
  const dispatch = useAppDispatch();
  const mission = useAppSelector(selectMission);

  const setMission = (values) => dispatch(_setMission(values));
  const clearMission = () => dispatch(_clearMission());

  return {
    mission,
    setMission,
    clearMission,
  };
}
